module.exports = __webpack_public_path__ + "img/logo-navy-horizontal.fdb982d3.svg";